// extracted by mini-css-extract-plugin
export default {"divLogin":"Login_divLogin__7ymHL","pLogin":"Login_pLogin__Zi280","imgLogin":"Login_imgLogin__bBHo0"};